import React from 'react'
import { Button, Popconfirm, notification } from 'antd'
import { DeleteOutlined } from '@ant-design/icons'
import { useUploader } from './UploaderContext'
import { useAssetDelivery } from '../AssetDeliveryContext'

const DeleteAllAssets = () => {
  const { deleteAssetDeliveriesByProduct } = useAssetDelivery()
  const { product, uploaders, dispatch } = useUploader()

  const updateUploaders = (data: any) => {
    dispatch({
      type: 'UPDATE_UPLOADS',
      data: uploaders.map((upload) => ({
        upload,
        data,
      })),
    })
  }

  const confirm = async () => {    
    try {
      updateUploaders({
        shouldDelete: false,
        isDeleting: true,
        shouldUpdate: false,
      })
      
      const { deleteResults } = await deleteAssetDeliveriesByProduct(product.id)

      const deletedSuccessResults = deleteResults.filter((r: any) => r.wasDeleted)
      const deletedFailedResults = deleteResults.filter((r: any) => !r.wasDeleted)

      if (deletedSuccessResults.length > 0) {
        dispatch({
          type: 'REMOVE_UPLOADS',
          ids: deletedSuccessResults.map((r: any) => r.id),
        })
      }

      if (deletedFailedResults.length > 0) {
        updateUploaders({ isDeleting: false })
        notification.error({
          message: 'Noe gikk galt',
          description: (
            <ul>
              {deletedFailedResults.map((r: any, i: number) => (
                <li key={i}>{r.error}</li>
              ))}
            </ul>
          ),
          duration: null,
        })
      }
    } catch (err) {
      updateUploaders({ isDeleting: false })
      notification.error({
        message: 'Noe gikk galt',
        description: err.message,
      })
    }
  }

  const isDisabled = uploaders.length === 0

  const isLoading =
    uploaders.length > 1 &&
    uploaders.every((upload) => upload.shouldDelete || upload.isDeleting)

  return (
    <Popconfirm
      title="Er du sikker du vil slette alle opplastinger for dette produktet?"
      onConfirm={confirm}
      okText="Ja"
      cancelText="Avbryt"
      disabled={isDisabled}
    >
      <Button
        icon={<DeleteOutlined />}
        size="small"
        danger
        disabled={isDisabled}
        loading={isLoading}
      >
        Slett alle
      </Button>
    </Popconfirm>
  )
}

export default DeleteAllAssets
